import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { Lock, CheckCircle, Cloud } from '@mui/icons-material';


interface FeatureCardProps {
    image: string;
    title: string;
    description: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ image, title, description }) => (
    <div className="col-md-4 mb-4">
        <div className="card h-100 text-center">
            <img src={image} className="card-img-top" alt={title} style={{ height: '200px', objectFit: 'cover' }} />
            <div className="card-body">
                <h5 className="card-title">{title}</h5>
                <p className="card-text text-muted">{description}</p>
            </div>
        </div>
    </div>
);
const Security: React.FC = () => {
    const features = [
        {
            image: 'End-to-End-Encryption.jpg',
            title: 'End-to-End Encryption',
            description: 'Your files are protected.',
        },
        {
            image: 'GDPR.jpg',
            title: 'GDPR & CCPA Compliant',
            description: 'We follow strict privacy standards.',
        },
        {
            image: '/fullAccess.jpg',
            title: 'Secure Cloud Storage',
            description: 'Access transcriptions anytime, anywhere.',
        },
    ];

    return (
        <div className="container py-5">
            <h2 className="text-center mb-4">Your Data is Safe with Us</h2>
            <div className="row">
                {features.map((item, index) => (
                    <FeatureCard key={index} {...item} />
                ))}
            </div>
        </div>
    );
};

export default Security;
